import { FaBalanceScale, FaEnvelope, FaGlobe } from "react-icons/fa";

const sections = [
  {
    title: "1. Acceptance of Terms",
    content:
      "By using this website or participating in any program, you agree to these Terms, Privacy Policy, and posted community guidelines.",
  },
  {
    title: "2. Eligibility",
    content:
      "The platform primarily serves students, mentors, and alumni of Green University of Bangladesh.",
  },
  {
    title: "3. Community Code of Conduct",
    content:
      "Members must avoid plagiarism, respect others, and follow contest rules. Violations may lead to removal.",
  },
  {
    title: "4. Intellectual Property",
    content:
      "Content including problems, graphics, and posts belong to GUB CPC or respective owners and cannot be reused without permission.",
  },
  {
    title: "5. User Submissions",
    content:
      "You confirm submissions are your own and grant GUB CPC a non-exclusive license to display and promote them.",
  },
  {
    title: "6. Contests and Events",
    content:
      "Cheating or unsportsmanlike behavior may result in disqualification and further disciplinary action.",
  },
  {
    title: "7. Account Security",
    content:
      "You are responsible for account credentials and should report unauthorized access immediately.",
  },
  {
    title: "8. Website Availability",
    content:
      "We aim for consistent uptime but cannot guarantee uninterrupted availability due to maintenance or technical issues.",
  },
  {
    title: "9. Third-Party Links",
    content:
      "We may link to external services and are not responsible for their content or practices.",
  },
  {
    title: "10. Limitation of Liability",
    content:
      "GUB CPC is not liable for loss or disruption caused by issues outside reasonable operational control.",
  },
  {
    title: "11. Modifications",
    content:
      "Terms may be updated at any time. Continued use indicates acceptance of updated terms.",
  },
];

const TermsAndConditions = () => {
  return (
    <main className="home-shell min-h-screen px-4 pb-14 pt-28 sm:px-6">
      <section className="home-section border-none px-0 py-0">
        <div className="home-container">
          <div className="home-card-strong p-8 sm:p-10">
            <span className="section-kicker">Legal</span>
            <h1 className="home-title mt-4 text-3xl font-bold sm:text-5xl">Terms and Conditions</h1>
            <p className="mt-3 inline-flex items-center gap-2 text-sm home-muted">
              <FaBalanceScale className="home-accent" /> Effective Date: June 25, 2025
            </p>
            <p className="mt-4 max-w-3xl text-sm sm:text-base home-muted">
              By accessing this platform, you agree to follow the terms below.
            </p>
          </div>
        </div>
      </section>

      <section className="home-section border-none px-0 pt-8">
        <div className="home-container space-y-3 home-stagger-stack">
          {sections.map((section) => (
            <article key={section.title} className="home-card p-5 sm:p-6">
              <h2 className="text-lg font-semibold home-accent">{section.title}</h2>
              <p className="mt-2 text-sm leading-7 home-muted">{section.content}</p>
            </article>
          ))}

          <div className="home-card-strong p-6">
            <h2 className="text-lg font-semibold">12. Contact Us</h2>
            <p className="mt-2 text-sm home-muted">
              Questions about these terms can be sent through:
            </p>
            <div className="mt-4 flex flex-wrap gap-2 text-sm">
              <a href="mailto:contact@gubcpa.com" className="home-btn-secondary inline-flex items-center gap-2 px-4 py-2">
                <FaEnvelope className="home-accent" /> contact@gubcpa.com
              </a>
              <a href="https://gubcpa.com" target="_blank" rel="noreferrer" className="home-btn-secondary inline-flex items-center gap-2 px-4 py-2">
                <FaGlobe className="home-accent" /> gubcpa.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsAndConditions;
